import ProductItem, {
	ProductItemProps
} from 'components/ProductItem/ProductItem';

export type { ProductItemProps };
export default ProductItem;
